import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "error"]
  static values = {
    maxFileSize: { type: Number, default: 512000 },
    invalidTypeMessage: String,
    fileTooLargeMessage: String,
  }

  connect() {
    this.allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"]
  }

  pickFile() {
    this.inputTarget.click()
  }

  capturePhoto() {
    this.inputTarget.setAttribute("capture", "environment")
    this.inputTarget.click()
  }

  previewFile(event) {
    const file = event.target.files[0]
    if (!file) return

    // Clear previous errors
    this.clearErrors()

    // Validate file
    const validationError = this.validateFile(file)
    if (validationError) {
      this.showError(validationError)
      this.clearPreview()
      event.target.value = ""
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result
      this.previewTarget.classList.remove("hidden")
      this.placeholderTarget.classList.add("hidden")
    }
    reader.readAsDataURL(file)
  }

  validateFile(file) {
    // Check file type
    if (!this.allowedTypes.includes(file.type)) {
      return this.invalidTypeMessageValue
    }

    // Check file size
    if (file.size > this.maxFileSizeValue) {
      const maxSizeKB = Math.round(this.maxFileSizeValue / 1024)
      return this.fileTooLargeMessageValue.replace("%{size}", maxSizeKB + "KB")
    }

    return null
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove("hidden")
    } else {
      alert(message)
    }
  }

  clearErrors() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
  }

  clearPreview() {
    this.previewTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
    this.previewTarget.src = ""
  }
}
